import { Injectable } from '@angular/core';

import { LocalStorageService, SessionStorageService, SyncStorage } from 'ngx-webstorage';
import { isNil } from 'lodash';
import { Usuario, Token } from './../shared/interfaces'

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    private _local = false;
    constructor(private _localStorage: LocalStorageService, private _sesionStorage: SessionStorageService) {
        this._local = isNil(this._sesionStorage.retrieve('usuario'))
    }

    get storage(): SyncStorage {
        return this._local ? this._localStorage : this._sesionStorage;
    }

    get localStorage(): SyncStorage {
        return this._localStorage;
    }

    get sesionStorage(): SyncStorage {
        return this._sesionStorage;
    }

    get usuario(): Usuario {
        return this.storage.retrieve('usuario');
    }

    set usuario(value: Usuario) {
        if (isNil(value)) {
            this.storage.clear('usuario');
        } else {
            this.storage.store('usuario', value);
        }
    }

    get token(): Token {
        return this.storage.retrieve('token');
    }

    set token(value: Token) {
        if (isNil(value)) {
            this.storage.clear('token')
        } else {
            this.storage.store('token', value)
        }
    }

    get local(): boolean {
        return this._local;
    }

    set local(value: boolean) {
        this._local = value;
        if (value) {
            this._sesionStorage.clear('usuario');
            this._sesionStorage.clear('token');
        }
    }
}